@if (collection?.length && (title || filterCategories?.length)) {
  <div class="select" fxLayout="row wrap" fxLayoutAlign="space-between center" @fadeInAnimation>
    <div>
      @if (title) {
        <h4>{{ title }}</h4>
      }
    </div>
    <div class="filters_container" fxLayout="row wrap" fxLayoutAlign="end center" fxLayoutGap=" 1.25rem">
      @for (filter of filterCategories; track filter) {
        @if (filterOptions[filter.key]?.length > 1) {
          <mat-form-field>
            <mat-label>Filter by {{ filter.title }}</mat-label>
            <mat-select
              (selectionChange)="filterCollection(collection, filter.key, $event.value)"
              [value]="filterValues[filter.key]"
            >
              @for (option of filterOptions[filter.key]; track option; let index = $index) {
                <mat-option [value]="filter.key === 'start_date' ? index : option">
                  {{ option }}
                </mat-option>
              }
              <mat-option [value]="false">See All</mat-option>
            </mat-select>
          </mat-form-field>
        }
      }
    </div>
  </div>
}
<ess-scroll-gallery-wrapper>
  @for (item of filteredCollection; track item) {
    <div
      data-cy="scroll-gallery-item"
      class="item"
      [ngClass]="{pointer: type === 'area' || type === 'neighborhood'}"
      fxFlex="1 1 9.375rem"
      (click)="emitItemClicked($event, item)"
      @fadeInAnimation
    >
      <!-- default -->
      @if (link && type !== 'days') {
        <a [href]="buildLink(link, item)" target="_blank">
          <div class="item_image">
            <figure>
              <img [src]="getImageUrl(item.featured_image || item.image, 150, 150)" />
            </figure>
          </div>
          <h2>{{ item.title }}</h2>
          @if (item.description) {
            <div class="item_description" [title]="item.description">
              <span [innerHTML]="item.description | slice: 0 : 60"></span><span>...</span>
            </div>
          }
          @if (item.category || item.subcategory) {
            <h5 class="category">
              {{ item.category }}
              @if (item.category !== item.subcategory && !item.start_date && !item.end_date) {
                <span>
                  {{ item.subcategory }}
                </span>
              }
              @if (item.start_date || item.end_date) {
                <span>
                  {{ item.start_date | date: 'EEEE, MMM d, y' }}
                  @if (item.end_date) {
                    <span> - </span>
                  }
                  {{ item.end_date | date: 'EEEE, MMM d, y' }}
                </span>
              }
              @if (item.neighborhood) {
                <span>
                  {{ item.neighborhood }}
                </span>
              }
            </h5>
          }
          @if (item.user || item.arrival_date) {
            <h5>
              {{ item.user }}
              @if (item.arrival_date) {
                <span>
                  {{ item.arrival_date | date: 'EEEE, MMM d, y' }}
                </span>
              }
            </h5>
          }
          @if (item.city) {
            <h5 class="grayed">
              {{ item.city }}
            </h5>
          }
          @if (item.exclusive_hotel) {
            <h5 class="related">
              Exclusive for guests of:
              <span>{{ item.exclusive_hotel.title }}</span>
            </h5>
          }
          @if (item.is_amex) {
            <div class="amex-tag">Amex</div>
          }
          <ess-experience-ranking [internalRanking]="item.internal_ranking"></ess-experience-ranking>
        </a>
      } @else {
        <div class="item_image" fxLayoutAlign="end start">
          <figure>
            <img [src]="getImageUrl(item.featured_image || item.image, 150, 150)" />
          </figure>
        </div>
        <h2>{{ item.title }}</h2>
        @if (item.description) {
          <div class="item_description" [title]="item.description">
            <span [innerHTML]="item.description | slice: 0 : 60"></span><span>...</span>
          </div>
        }
      }
      <!-- neighborhood -->
    </div>
  }
</ess-scroll-gallery-wrapper>
